import { Banner } from '@mm/components';
import { SmsKeywordIcon } from '@mm/icons/StarterIcons';
import React from 'react';
import useRouter from 'use-react-router';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { SETTINGS_SMS } from '../../../../../../common/constants/routes';
import { useGreenCueMarkers } from '../../../../../../common/hooks/use-green-cue-markers';
import { useFreeTrialUpgradeModal } from '../../../../../../common/modals/FreeTrialUpgradeModal/use-free-trial-upgrade-modal';
import './ActivateSmsBanner.pcss';
import IphoneIconCut from './IphoneIconCut.png';

const checkPoints = [
  'Get a unique, local phone number!',
  'Create Text Keywords and Opt-in Popups to build your list!',
  'Send SMS Chat Blasts and Drip Campaigns powered by your Chatbot!',
];

export const ActivateSmsBanner = () => {
  const {
    location,
    history,
    match: {
      params: { chatbotId },
    },
  } = useRouter<{ chatbotId: string }>();

  const { isSmsActivated } = useGreenCueMarkers();
  const { isFreeTrialPromotionWithoutSubscription } =
    useFreeTrialUpgradeModal();

  return (
    <Banner
      css={{ container: 'activate-sms-banner' }}
      title="Activate SMS to reach more people on the most popular chat format in the world: text messages."
      checkpointsText={checkPoints}
      showGreenMarker={
        !isSmsActivated && isFreeTrialPromotionWithoutSubscription
      }
      button={
        <PrimaryButton
          onClick={() =>
            history.push({
              pathname: SETTINGS_SMS(Number(chatbotId)),
              state: {
                navigatedFrom: {
                  location: location.pathname,
                  search: location.search,
                },
              },
            })
          }
          leftIcon={<SmsKeywordIcon color="#fff" />}
          color={ButtonColor.green}
        >
          Activate SMS
        </PrimaryButton>
      }
    >
      <img
        src={IphoneIconCut}
        className="c-banner__iphone-icon activate-sms-banner__phone-icon"
      />
    </Banner>
  );
};
